import type { VFC } from 'react';
import { useMemo } from 'react';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { AssetContainer } from '../AssetContainer/AssetContainer';
import { Player } from '../Player/Player';
import { AssetDetails } from '../AssetDetails/AssetDetails';
import {
  getAssetChapters,
  getAssetTags,
} from '../../shared/helpers/assetHelpers';
import { AssetMetadata } from '../AssetMetadata/AssetMetadata';

import * as styles from './PlayerWithDocumentaryDetails.module.scss';

interface PlayerWithDocumentaryDetailsProps {
  asset: SvpAssetAdditional;
  startTime?: number;
}

const PlayerWithDocumentaryDetails: VFC<PlayerWithDocumentaryDetailsProps> = ({
  asset,
  startTime,
}) => {
  const { title, description } = asset;

  const labels = useMemo(() => {
    return [asset.category.title];
  }, [asset]);

  return (
    <AssetContainer asset={asset} className={styles.container}>
      <Player asset={asset} startTime={startTime} />
      <AssetDetails
        title={title}
        chapters={getAssetChapters(asset)}
        description={description}
        tags={getAssetTags(asset)}
        labels={labels}
        metadata={<AssetMetadata asset={asset} />}
      />
    </AssetContainer>
  );
};

export { PlayerWithDocumentaryDetails };
